import axios from 'axios';
import { BASE_API_URL } from '../constants/env';

export const getAdjustmentsHistory = async (token, page, size, sortField, filtersData) => {
    const url = sortField
        ? `${BASE_API_URL}/stock-movements/adjustment-history?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock-movements/adjustment-history?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getAdjustmentsHistory call: ', error);
            return error;
        });
};

export const getAdjustmentMovements = async (token, page, size, sortField, filtersData, pathVariables) => {
    sortField = sortField ? sortField : 'createdDate,desc';
    const url = `${BASE_API_URL}/stock-movements/articleId/${pathVariables.articleId}/brand/${pathVariables.brand}/adjustments?page=${page}&size=${size}&sort=${sortField}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getAdjustmentMovements call: ', error);
            return error;
        });
};

export const getStockFinancialValue = async (token) => {
    const url = `${BASE_API_URL}/stock/value`;

    return axios
        .get(url, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getStockFinancialValue call: ', error);
            return error;
        });
};

export const getStockFinancialByTags = async (token, page, size, sortField, filtersData) => {
    sortField = sortField ? sortField : 'tagValue,desc';
    const url = `${BASE_API_URL}/stock/tag-value?page=${page}&size=${size}&sort=${sortField}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getStockFinancialByTags call: ', error);
            return error;
        });
};

export const getMovementDistribution = async (token) => {
    const url = `${BASE_API_URL}/stock-movements/percentage`;

    return axios
        .get(url, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getMovementDistribution call: ', error);
            return error;
        });
};

export const getMovementsByMonthReport = async (token, page, size, sortField, filtersData) => {
    const url = sortField
        ? `${BASE_API_URL}/stock-movements/monthly-report?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock-movements/monthly-report?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getMovementsByMonthReport call: ', error);
            return error;
        });
};

export const getStockReport = async (token, page, size, sortField, filtersData) => {
    const url = sortField
        ? `${BASE_API_URL}/stock/by-article?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock/by-article?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getStockReport call: ', error);
            return error;
        });
};

export const getReceiptsByProviderReport = async (token, page, size, sortField, filtersData) => {
    const url = sortField
        ? `${BASE_API_URL}/stock-movements/receipt/by-provider?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock-movements/receipt/by-provider?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getReceiptsByProviderReport call: ', error);
            return error;
        });
};

export const getReceiptsByArticleReport = async (token, page, size, sortField, filtersData) => {
    const url = sortField
        ? `${BASE_API_URL}/stock-movements/receipt/by-article?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock-movements/receipt/by-article?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getReceiptsByArticleReport call: ', error);
            return error;
        });
};

export const getReceiptsByArticleReportTotalValue = async (token, filtersData) => {
    const url = `${BASE_API_URL}/stock-movements/receipt/by-article/total`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getReceiptsByArticleReportTotalValue call: ', error);
            return error;
        });
};

export const getIssuesByVehicleReport = async (token, page, size, sortField, filtersData) => {
    const url = sortField
        ? `${BASE_API_URL}/stock-movements/issue/by-vehicle?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock-movements/issue/by-vehicle?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getIssuesByVehicleReport call: ', error);
            return error;
        });
};

export const getReportIssuesByVehicleTotalValue = async (token, filtersData) => {
    const url = `${BASE_API_URL}/stock-movements/issue/by-vehicle/total`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getReportIssuesByVehicleTotalValue call: ', error);
            return error;
        });
};

export const getVehicleIssuesDetails = async (token, page, size, sortField, filtersData, pathVariables) => {
    const url = sortField
        ? `${BASE_API_URL}/stock-movements/issue/vehicle/${pathVariables.vehicleId}/articles?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock-movements/issue/vehicle/${pathVariables.vehicleId}/articles?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getVehicleIssuesDetails call: ', error);
            return error;
        });
};

export const getVehicleDetailsTotalValue = async (token, filtersData, pathVariables) => {
    const url = `${BASE_API_URL}/stock-movements/issue/vehicle/${pathVariables.vehicleId}/articles/total`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getVehicleDetailsTotalValue call: ', error);
            return error;
        });
};

export const getIssuesByArticleReport = async (token, page, size, sortField, filtersData) => {
    const url = sortField
        ? `${BASE_API_URL}/stock-movements/issue/by-article?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock-movements/issue/by-article?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getIssuesByArticleReport call: ', error);
            return error;
        });
};

export const getReportIssuesByArticleTotalValue = async (token, filtersData) => {
    const url = `${BASE_API_URL}/stock-movements/issue/by-article/total`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getReportIssuesByArticleTotalValue call: ', error);
            return error;
        });
};

export const getArticleIssuesDetails = async (token, page, size, sortField, filtersData, pathVariables) => {
    const url = sortField
        ? `${BASE_API_URL}/stock-movements/issue/article/${pathVariables.articleId}/details?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock-movements/issue/article/${pathVariables.articleId}/details?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getArticleIssuesDetails call: ', error);
            return error;
        });
};

export const getArticleDetailsTotalValue = async (token, filtersData, pathVariables) => {
    const url = `${BASE_API_URL}/stock-movements/issue/article/${pathVariables.articleId}/details/total`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getArticleDetailsTotalValue call: ', error);
            return error;
        });
};

export const getProviderReceiptsDetails = async (token, page, size, sortField, filtersData, pathVariables) => {
    const url = sortField
        ? `${BASE_API_URL}/stock-movements/receipt/provider/${pathVariables.providerId}/articles?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock-movements/receipt/provider/${pathVariables.providerId}/articles?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getProviderReceiptsDetails call: ', error);
            return error;
        });
};

export const getMinimumReport = async (token, page, size, sortField, filtersData) => {
    const url = sortField
        ? `${BASE_API_URL}/stock/minimum?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock/minimum?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getMinimumReport call: ', error);
            return error;
        });
};

export const getMinimumPercentage = async (token) => {
    const url = `${BASE_API_URL}/stock/minimum/percentage`;

    return axios
        .get(url, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getMinimumReport call: ', error);
            return error;
        });
};

export const getIssuesByWorkOrderReport = async (token, page, size, sortField, filtersData) => {
    const url = sortField
        ? `${BASE_API_URL}/stock-movements/issue/by-work-order?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock-movements/issue/by-work-order?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getIssuesByWorkOrderReport call: ', error);
            return error;
        });
};

const transformFiltersForWorkOrderDetails = (filters) => {
    let transformedFilters = [];

    filters.forEach((filter) => {
        if (filter.operation === 'between' && filter.value && Array.isArray(filter.value) && filter.value.length === 2) {
            // Transformar filtros de rango a formato Low/High
            if (filter.columnName === 'amount') {
                if (filter.value[0] !== null && filter.value[0] !== undefined && filter.value[0] !== '') {
                    transformedFilters.push({
                        columnName: 'amountRangeLow',
                        operation: 'between',
                        values: [parseFloat(filter.value[0])],
                    });
                }
                if (filter.value[1] !== null && filter.value[1] !== undefined && filter.value[1] !== '') {
                    transformedFilters.push({
                        columnName: 'amountRangeHigh',
                        operation: 'between',
                        values: [parseFloat(filter.value[1])],
                    });
                }
            } else if (filter.columnName === 'averageValue') {
                if (filter.value[0] !== null && filter.value[0] !== undefined && filter.value[0] !== '') {
                    transformedFilters.push({
                        columnName: 'averageRangeLow',
                        operation: 'between',
                        values: [parseFloat(filter.value[0])],
                    });
                }
                if (filter.value[1] !== null && filter.value[1] !== undefined && filter.value[1] !== '') {
                    transformedFilters.push({
                        columnName: 'averageRangeHigh',
                        operation: 'between',
                        values: [parseFloat(filter.value[1])],
                    });
                }
            } else if (filter.columnName === 'totalValue') {
                if (filter.value[0] !== null && filter.value[0] !== undefined && filter.value[0] !== '') {
                    transformedFilters.push({
                        columnName: 'totalRangeLow',
                        operation: 'between',
                        values: [parseFloat(filter.value[0])],
                    });
                }
                if (filter.value[1] !== null && filter.value[1] !== undefined && filter.value[1] !== '') {
                    transformedFilters.push({
                        columnName: 'totalRangeHigh',
                        operation: 'between',
                        values: [parseFloat(filter.value[1])],
                    });
                }
            } else {
                transformedFilters.push({
                    ...filter,
                    values: filter.value,
                });
            }
        } else {
            const transformedFilter = { ...filter };
            if (transformedFilter.value && !transformedFilter.values) {
                transformedFilter.values = Array.isArray(transformedFilter.value) ? transformedFilter.value : [transformedFilter.value];
                delete transformedFilter.value;
            }
            transformedFilters.push(transformedFilter);
        }
    });

    return transformedFilters;
};

export const getWorkOrderIssuesDetails = async (token, page, size, sortField, filtersData, pathVariables) => {
    // Transformar filtros al formato que espera esta API específica
    const transformedFilters = transformFiltersForWorkOrderDetails(filtersData);

    const url = sortField
        ? `${BASE_API_URL}/stock-movements/issue/work-order/${pathVariables.workOrderId}/articles?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/stock-movements/issue/work-order/${pathVariables.workOrderId}/articles?page=${page}&size=${size}`;

    return axios
        .post(url, transformedFilters, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getWorkOrderIssuesDetails call: ', error);
            return error;
        });
};

export const getInternalServicesReport = async (token, page, size, sortField, filtersData) => {
    const url = sortField
        ? `${BASE_API_URL}/work-orders/performed-works/search?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/work-orders/performed-works/search?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getInternalServicesReport call: ', error);
            return error;
        });
};

export const getExternalServicesReport = async (token, page, size, sortField, filtersData) => {
    const url = sortField
        ? `${BASE_API_URL}/work-orders/external-works/search?page=${page}&size=${size}&sort=${sortField}`
        : `${BASE_API_URL}/work-orders/external-works/search?page=${page}&size=${size}`;

    return axios
        .post(url, filtersData, {
            headers: {
                Authorization: 'Bearer ' + token,
            },
        })
        .then((response) => {
            const { data } = response;
            return data;
        })
        .catch((error) => {
            console.log('Error on getExternalServicesReport call: ', error);
            return error;
        });
};
